// extracted by mini-css-extract-plugin
export default {"preloaderItem":"nIMAEys"};